import { useState } from 'react';
import { deleteAlert } from 'api/alerts';
import { Alert } from 'api/alerts/alerts.types';
import { ResStatus } from 'api/api.types';
import {
  getAlertsCountState,
  getAlertsInboxState,
  useAlerts,
} from 'contexts/alertsContext/alertsContext';
import { useTranslation } from 'react-i18next';
import { Notification } from './Notification';
import * as S from './Notifications.css';

const INITIAL_VISIBLE = 3;

interface Props {
  notifications: Alert[];
}

export const NotificationList = ({ notifications }: Props) => {
  const { dispatch } = useAlerts();
  const [deletingId, setDeletingId] = useState<number | null>(null);
  const [showAll, setShowAll] = useState(false);

  const { t } = useTranslation(['homePage', 'misc']);

  const handleDeleteNotification = async (id: number) => {
    setDeletingId(id);
    const res = await deleteAlert(id);
    if (res.data.status === ResStatus.OK) {
      await getAlertsInboxState(dispatch);
      await getAlertsCountState(dispatch);
    }
    setDeletingId(null);
  };

  const visibleNotifications = showAll
    ? notifications
    : notifications.slice(0, INITIAL_VISIBLE);
  const hiddenCount = notifications.length - INITIAL_VISIBLE;

  return (
    <S.NotificationsContainer>
      <S.Title>{t('notifications', { ns: 'homePage' })}</S.Title>
      {notifications.length !== 0 &&
        visibleNotifications.map((notification) => (
          <Notification
            key={notification.id}
            notification={notification}
            handleDelete={handleDeleteNotification}
            isDeleting={deletingId === notification.id}
          />
        ))}
      {!showAll && hiddenCount > 0 && (
        <S.ShowMoreLink onClick={() => setShowAll(true)}>
          {t('button.showMore', { ns: 'misc', count: hiddenCount })}
        </S.ShowMoreLink>
      )}
    </S.NotificationsContainer>
  );
};
